"use strict";
var Promise = require("promise6");
var par = require("par");
var ponyfill = require("fetch-ponyfill")();
var fetch = ponyfill.fetch;
var Headers = ponyfill.Headers;
var btoa = require("abab").btoa;

var DEFAULT_ICE = [{
	url: 'stun:stun.l.google.com:19302'
}];

var TIMEOUT_INTERVAL = 5 * 1000; // 5 seconds

module.exports = get_ice_servers;

/**
 * Gets references to Ice servers from xirsys
 * @return {Promise} Resolves to array of ice servers to use
 */
function get_ice_servers(skipIce, host) {
	if (skipIce) return Promise.resolve([]);

	var timeout = make_timeout();
	var data = get_data(host);

	return Promise.race([data, timeout]);
}

function get_data(host) {
	var url = `${host}/v2/call/iceservers`;
	
	var options = {
		method: "GET"
	};
	
	return fetch(url, options)
		.then(loadAsJSON)
		.then(handle_list)
		.catch(handle_error);
}

function loadAsJSON(response) {
	return response.json();
}

function handle_list(result) {
	return result.concat(DEFAULT_ICE);
}

function handle_error(error) {
	console.debug("XirSys fetch error:", error, error.response);
	return DEFAULT_ICE;
}

function make_timeout() {
	return new Promise(function (resolve) {
		setTimeout(par(resolve, DEFAULT_ICE), TIMEOUT_INTERVAL);
	});
}
